import { ColDef, ColGroupDef } from "ag-grid-community";
import { ExcelExportRole } from "../../RolePanelTypes";
import { BasePermissionGrid } from "./BasePermissionGrid";

export class ExcelExportRoleGrid extends BasePermissionGrid<ExcelExportRole> {
    id: string = "ExcelExportRoles";
    gridClass: string = "permissionGrid";
    protected endpoint: string = "/rolePanel/excelExportRoles";
    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: "RecordName", headerName: "Record Name", flex: 3, resizable: false },
            {
                field: "AllowExport",
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
        ];
    }
} 